export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "mapbox-gl-csp-worker-fc5f6aedc03c4e5b0d71.worker.js");
}
